import { CompaniesContent } from '@/components/tables/CompaniesContent'
import { type GroupOption } from '@valiant/ui-shared'

interface CompaniesTabProps {
  groupId?: string
  userId?: string
  searchTerm?: string
  preSelectedGroup?: GroupOption
  hideUnassignButton?: boolean
  hideAssignButton?: boolean
}

export function CompaniesTab({
  groupId,
  userId,
  searchTerm,
  preSelectedGroup,
  hideUnassignButton,
  hideAssignButton,
}: CompaniesTabProps = {}) {
  return (
    <CompaniesContent
      searchTerm={searchTerm}
      groupId={groupId}
      userId={userId}
      preSelectedGroup={preSelectedGroup}
      hideUnassignButton={hideUnassignButton}
      hideAssignButton={hideAssignButton}
    />
  )
}
